// ============================================================================
// page-author / projects.js
// ----------------------------------------------------------------------------
// "Related Projects" — left-aligned Flickity strip of projects where the
// architect ACF repeater includes the current author.
//
// The PHP in code block #353 only emits `.service-projects__card-item`
// elements when a project actually matches; if the author has none, the
// strip is empty. The original inline JS leaked a `$count` PHP global to
// detect this and hide the section. We do the same thing in JS-only by
// counting card items after DOM ready — no PHP coordination needed.
//
// Directional hover on the cards is auto-bound globally by
// directional-hover.js (no per-section re-init).
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".service-projects");
  const sliderEl = document.querySelector(".service-projects__card");
  if (!section || !sliderEl) return;

  const items = sliderEl.querySelectorAll(".service-projects__card-item");
  if (!items.length) {
    section.style.display = "none";
    return;
  }

  sliderEl.style.display = "block";

  const instances = initCarousels(".service-projects__card", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
    imagesLoaded: true,
  });
  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  const prev = document.querySelector(".service-projects__nav-button.prev");
  const next = document.querySelector(".service-projects__nav-button.next");
  if (prev)
    prev.addEventListener("click", function () {
      flkty.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      flkty.next();
    });
});
